module.exports = __webpack_public_path__ + "static/media/1.cfc3c6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/1.png
// module id = 219
// module chunks = 0